module.exports = __webpack_public_path__ + "assets/img/yypt_bg.780ce8b6.png";